module.exports = __webpack_public_path__ + "img/collection-weddingRingsMulticolor.476f157.jpg";